export default function AJAX_Database() {
  return (
    <div>
      <h1>AJAX_Database</h1>
      <p>This is the AJAX_Database component.</p>
    </div>
  );
}